





















import { Component, Prop, Vue } from 'vue-property-decorator';
import { MentoringMember } from '@/pages/profile/modules/mentoring/components';
import { IMentoringCrew, Child, Crew } from './types';

@Component({
  components: {
    MentoringMember,
  },
})
export default class MentoringCrew extends Vue implements IMentoringCrew {
  @Prop({ type: String, default: '' })
  readonly title!: string;

  @Prop({ type: Array, default: () => [] })
  readonly crew!: Crew;

  @Prop({ type: Object, default: () => {} })
  readonly child!: Child;
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/modules/mentoring/teamcard/components/crew/MentoringCrew.vue